export default __webpack_public_path__ + "static/lamiapron-023b9f44f9d3b1aef43a2f261e8685c5.jpg";